function parsePlaceholder (raw, defaultValue) {
    try {
        // processing true/false/0/1/123/12.5...
        return JSON.parse(raw)
    } catch (e) {
        return typeof(defaultValue) !== 'undefined' ? defaultValue : null
    }
}

export default key => {
    const receiptHistoryIntervalDays = parseInt('8');
    let vars = {
        RECEIPT_HISTORY_INTERVAL_DAYS: !isNaN(receiptHistoryIntervalDays) && receiptHistoryIntervalDays > 0 ? receiptHistoryIntervalDays : 8,
        APP_URL: 'https://pop-staging-api.scaleragency.io',
        PUSHER_APP_KEY: '2843b4105f0158f72dcd',
        LOGROCKET_ID: '$LOGROCKET_ID',
        DECLUTTER_COMPANY_ADDRESS: 'Maglódi út 47.',
        DECLUTTER_COMPANY_CITY: 'Budapest',
        DECLUTTER_COMPANY_NAME: 'Nozo-Duo Bt.',
        DECLUTTER_COMPANY_POSTAL_CODE: '1106',
        SHOW_MENU_APP_VERSIONS: parsePlaceholder('true'),
        SHOW_MENU_AUDIT: parsePlaceholder('true'),
        SHOW_MENU_CARS: parsePlaceholder('true'),
        SHOW_MENU_CENTRAL: parsePlaceholder('true'),
        SHOW_MENU_DECLUTTERS: parsePlaceholder('true'),
        SHOW_MENU_DOCKETS: parsePlaceholder('true'),
        SHOW_MENU_DOC_VERSIONS: parsePlaceholder('true'),
        SHOW_MENU_INVOICES: parsePlaceholder('true'),
        SHOW_MENU_INVOICE_BOOKS: parsePlaceholder('true'),
        SHOW_MENU_PACKINGS: parsePlaceholder('true'),
        SHOW_MENU_PALLET_REPORT: parsePlaceholder('true'),
        SHOW_MENU_REPRESENTATIVES: parsePlaceholder('true'),
        SHOW_MENU_REPRESENTATIVE_DELIVERIES: parsePlaceholder('true'),
        SHOW_MENU_REPRESENTATIVE_ORDERS: parsePlaceholder('true'),
        SHOW_MENU_REPRESENTATIVE_PROCESSES: parsePlaceholder('true'),
        SHOW_MENU_SHOPS: parsePlaceholder('true'),
        SHOW_MENU_STOCK_TRANSFORMATIONS: parsePlaceholder('true'),
        SHOW_MENU_TAXING: parsePlaceholder('true'),
        SHOW_STORAGE_TOOLTIPS: parsePlaceholder('true'),
        STORAGE_TOOLTIP_SUFFIX: 'Csak központi raktár választható.',
        PIROS_MOGYOROS_ALLOWED: parsePlaceholder('true'),
        SHOW_MENU_STOCK_MOVEMENTS: parsePlaceholder('true'),
    }

    Object.keys(vars).forEach(item => {
        if (typeof(process.env[`VUE_APP_${item}`]) !== 'undefined') {
            const raw = process.env[`VUE_APP_${item}`]
            vars[item] = parsePlaceholder(raw, raw)
        }
    })

    return vars[key];
}
